import { ModuleInitializer, ModuleInitializerHelper } from '@workflow/helper/module-initializer/module-initializer.class';
import { PRODUCT_MORTGAGE, PRODUCT_OAO } from './product-helper';
import { CustomFunctionsService } from './service/logic-functions/custom-functions.service';
import { OnChangeFunctionsService } from './service/logic-functions/on-change-functions.service';
import { OnClickFunctionsService } from './service/logic-functions/on-click-functions.service';
import { VisibleFunctionsService } from './service/logic-functions/visible-functions.service';
import { CardValidationFunctionsService } from './service/validations/card-validation-functions.service';
import { FieldValidationFunctionsService } from './service/validations/field-validation-functions.service';
import { PageValidationFunctionsService } from './service/validations/page-validation-functions.service';

export class DynamicAppModuleInit {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public static init(routeInit?: { PageComponent: any; guard: any }): ModuleInitializer {
    const initializer = new ModuleInitializerHelper()
      .AddValidationService(PageValidationFunctionsService)
      .AddValidationService(CardValidationFunctionsService)
      .AddValidationService(FieldValidationFunctionsService)

      .AddLogicService(CustomFunctionsService)
      .AddLogicService(VisibleFunctionsService)
      .AddLogicService(OnChangeFunctionsService)
      .AddLogicService(OnClickFunctionsService);

    if (routeInit) {
      initializer.AddRoute('', routeInit.PageComponent, routeInit.guard, PRODUCT_OAO, PRODUCT_MORTGAGE);
    }
    return initializer;
  }
}
